module.exports = __webpack_public_path__ + "static/electricity-maps-e88f990c9f74cb5dd99513fbd5c6f1d5.png";